var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 63,
    viewBox: "0 0 81 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 34.5742L16.1051 36.75L15.1484 32.6492L18.3334 29.89L14.1392 29.5342L12.5001 25.6667L10.8609 29.5342L6.66675 29.89L9.85175 32.6492L8.89508 36.75L12.5001 34.5742Z",
    fill: "#80959B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5001 34.5742L30.1051 36.75L29.1484 32.6492L32.3334 29.89L28.1392 29.5342L26.5001 25.6667L24.8609 29.5342L20.6667 29.89L23.8517 32.6492L22.8951 36.75L26.5001 34.5742Z",
    fill: "#80959B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5001 34.5742L44.1051 36.75L43.1484 32.6492L46.3334 29.89L42.1392 29.5342L40.5001 25.6667L38.8609 29.5342L34.6667 29.89L37.8517 32.6492L36.8951 36.75L40.5001 34.5742Z",
    fill: "#80959B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5001 34.5742L58.1051 36.75L57.1484 32.6492L60.3334 29.89L56.1392 29.5342L54.5001 25.6667L52.8609 29.5342L48.6667 29.89L51.8517 32.6492L50.8951 36.75L54.5001 34.5742Z",
    fill: "#80959B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3334 29.89L70.1392 29.5284L68.5001 25.6667L66.8609 29.5342L62.6667 29.89L65.8517 32.6492L64.8951 36.75L68.5001 34.5742L72.1051 36.75L71.1542 32.6492L74.3334 29.89ZM68.5001 33.4834L66.3067 34.8075L66.8901 32.3109L64.9534 30.6309L67.5084 30.4092L68.5001 28.0584L69.4976 30.415L72.0526 30.6367L70.1159 32.3167L70.6992 34.8134L68.5001 33.4834Z",
    fill: "#E6EAEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/Rating.fee247cca4b0eb9c2f1cda2e8371e70a.svg";
export { ForwardRef as ReactComponent };